/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getAlarm: state => (id) => state.alarms.find((alarm) => alarm.id == id),
  // getAlarm: state => (id) => state.alarms.find((alarm) => alarm.id == id)
  filteredAlarm: state => state.alarms.filter((alarm) => {
    if(state.alarmFilter == 'new'){
      if(alarm.unread == true && (alarm.title.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) || alarm.sender_name.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) ||
        alarm.sender_email.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) || alarm.create_time.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) ||
        alarm.detail.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()))){
        return true
      }
    }
    else if(state.alarmFilter == 'all'){
      return (alarm.title.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) || alarm.sender_name.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) ||
              alarm.sender_email.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) || alarm.create_time.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) ||
              alarm.detail.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()))
    }else{
      if(alarm.tag.toLowerCase().includes(state.alarmFilter.toLowerCase()) && (alarm.title.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) || alarm.sender_name.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) ||
        alarm.sender_email.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) || alarm.create_time.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()) ||
        alarm.detail.toLowerCase().includes(state.alarmSearchQuery.toLowerCase()))){
        return true
      }
    }
    return false
  }),
}
